import axios from 'axios'
import requestInterceptor from '../../requestInterceptor'
import responseInterceptor from '../../responseInterceptor'
import { fiscalServiceUrl } from '../../../../urls'

const headers = {
	'Content-Type': 'application/json',
	'X-Requested-With': 'XMLHttpRequest',
}

const fiscalInstance = axios.create({
	baseURL: fiscalServiceUrl,
	headers,
})

fiscalInstance.interceptors.request.use(config => {
	return requestInterceptor(config)
}, error => Promise.reject(error))

fiscalInstance.interceptors.response.use(response => response, error => {
	return responseInterceptor(error)
})

export default fiscalInstance
